export default __webpack_public_path__ + "static/media/brand_sistarbanc.06d1ff4a.svg";